import * as tslib_1 from "tslib";
import datapoints from 'owa-mail-list-store/lib/datapoints';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import setTableIsInCheckedMode from '../internal/mutators/setTableIsInCheckedMode';
import tableExitVirtualSelectAllMode from '../internal/mutators/tableExitVirtualSelectAllMode';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyPrefetchAdjacentItemsOnDelay } from 'owa-mail-prefetch';
import { onListViewSelectionChange } from 'owa-mail-module-orchestrator';
var propagateSelectionTask;
var lastSelectMailItemDatapoint;
/**
 * Called when there is a selection change in list view. This function will then trigger event to external
 * owa-mail-module-orchestrator to propagate selection change event
 * @param tableView The tableview
 * @param isUserNavigation Did user initiate selection
 * @param mailListItemSelectionSource The source of selection on mail item
 */
export default function onSelectionChange(tableView, isUserNavigation, mailListItemSelectionSource) {
    var selectedItemsCount = tableView.selectedRowKeys.size;
    if (selectedItemsCount > 0 && tableView.isInVirtualSelectAllMode) {
        // We have items selected, exit virtual selection mode if we're in it
        tableExitVirtualSelectAllMode(tableView);
    }
    else if (selectedItemsCount == 0 && !tableView.isInVirtualSelectAllMode) {
        // Nothing selected - reset checked mode
        setTableIsInCheckedMode(tableView, false);
    }
    if (selectedItemsCount == 1) {
        var rowKey = tslib_1.__spread(tableView.selectedRowKeys.keys())[0];
        lazyPrefetchAdjacentItemsOnDelay.importAndExecute(rowKey, tableView);
    }
    // We only need to honor the latest user selection
    if (propagateSelectionTask) {
        if (lastSelectMailItemDatapoint) {
            // end SelectMailItem datapoint from the previous selection
            lastSelectMailItemDatapoint.end(undefined /*duration*/, "BackgroundSuccess" /* BackgroundSuccess */);
        }
        clearTimeout(propagateSelectionTask);
        propagateSelectionTask = null;
    }
    if (mailListItemSelectionSource === MailListItemSelectionSource.SearchSuggestionClick) {
        // don't update list view if search email suggestion is opened in a tab
        if (!is3SFeatureEnabled('sea-emailSuggestionsInTab')) {
            // do not yield to let browser render list view. Search suggestion
            // opens into immersive reading pane directly with reading pane off.
            // The setTimeout causes list view to render briefly before
            // immersive reading pane is shown
            onListViewSelectionChange(tableView, isUserNavigation, mailListItemSelectionSource);
        }
        return Promise.resolve();
    }
    var promiseToReturn = new Promise(function (resolve, reject) {
        // Propagate the listview selection on delay so we allow the browser to render
        // listview selection change separately
        propagateSelectionTask = setTimeout(function () {
            propagateSelectionTask = null;
            onListViewSelectionChange(tableView, isUserNavigation, mailListItemSelectionSource)
                .then(function () {
                resolve();
            })
                .catch(function (error) {
                reject(error);
            });
        }, 1);
        lastSelectMailItemDatapoint = returnTopExecutingActionDatapoint(function (dp) {
            return dp.eventName == datapoints.SelectMailItemDatapoint.datapoint.name;
        });
    });
    return promiseToReturn;
}
//# sourceMappingURL=onSelectionChange.js.map